<template>
  <div id="manifest-item">
    <b-container v-if="manifest.id">
      <b-row>
        <b-col cols="12" md="10" offset-md="1">
          <b-row class="mb-3">
            <b-col class="align-self-center">
              <router-link :to="{ name: 'manifests' }" class="preview-link">
                <translate>« Go Back</translate>
              </router-link>
            </b-col>
            <b-col cols="3" class="align-self-center text-center">
              <b-button @click="print"><translate>Print Manifest</translate></b-button>
            </b-col>
            <b-col class="align-self-center text-right">
              <b-button variant="primary" :disabled="labelableShippings.length === 0 || generatingLabels" @click.prevent="bulkExportLabels">
                <b-spinner small v-if="generatingLabels"></b-spinner>
                <font-awesome-icon icon="file-pdf" size="1x" />&nbsp;&nbsp;<span v-translate="{labelableShippings: labelableShippings.length}">Export %{labelableShippings} PDF labels at once</span>
              </b-button>
            </b-col>
          </b-row>
          <b-card class="full-article-card" id="manifest">
            <b-row>
              <b-col class="align-self-center">
                {{moment().format('L LT')}}
              </b-col>
              <b-col class="text-right">
                <img :src="$store.getters.universe.logoLogin" alt="" style="width: auto; height: 100%; max-height: 40px;" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <hr>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="align-self-center">
                <h4 class="mb-0" v-translate="{route: $options.filters.uuid(manifest.id)}">Route: #%{route}</h4>
              </b-col>
              <b-col>
                <b-row v-if="manifest.courier">
                  <b-col cols="4" style="width: 50px !important;" class="align-self-center">
                    <b-img thumbnail :src="(manifest.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm')" class="profile-image" alt="img" style="width: 100%; height: auto;" />
                  </b-col>
                  <b-col class="align-self-center">
                    <h5>{{manifest.courier.name}} <small v-if="manifest.courier.tin"><small>({{ manifest.courier.tin }})</small></small></h5>
                    <strong class="plate" v-if="manifest.courier.courier_available && manifest.courier.courier_available.vehicle && manifest.courier.courier_available.vehicle.plate_number">{{ manifest.courier.courier_available.vehicle.plate_number }}</strong>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="align-self-center">
                <h5 class="mb-0 text-right" v-translate="{shippingsQty: manifest.shippings.length}">%{shippingsQty} shippings</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <hr>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="1" class="x">

              </b-col>
              <b-col cols="2">
                <strong v-translate>ID</strong>
              </b-col>
              <b-col cols="2" v-if="hasExternalCode">
                <strong v-translate>Code</strong>
              </b-col>
              <b-col cols="2" v-if="hasExternalOrderId">
                <strong v-translate>Order</strong>
              </b-col>
              <b-col cols="3">
                <strong v-translate>Destination Contact Name</strong>
              </b-col>
              <b-col>
                <strong v-translate>Destination Address</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <hr>
              </b-col>
            </b-row>
            <b-row v-for="(shipping, index) in manifest.shippings" :key="index">
              <b-col cols="1" style="font-size: 1.5rem; line-height: 1rem" class="x">
                ☐
              </b-col>
              <b-col cols="2">
                #{{shipping.id | uuid}}
              </b-col>
              <b-col cols="2" v-if="hasExternalCode">
                {{shipping.external_code}}
              </b-col>
              <b-col cols="2" v-if="hasExternalOrderId">
                {{shipping.external_order_id}}
              </b-col>
              <b-col cols="3">
                {{shipping.to_contact}}
              </b-col>
              <b-col>
                {{shipping.address_to.formatted_address}}
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import Spinner from '@/components/Spinner'

  export default {
    name: 'manifest-item',
    components: {
      Spinner
    },
    props: {
      id: {
        type: [String, Number],
        default: null
      }
    },
    data () {
      return {
        manifest: {},
        generatingLabels: false
      }
    },
    computed: {
      labelableShippings() {
        return this.manifest.shippings.map(x => {
          return x.id
        }).filter(Boolean)
      },
      hasExternalCode() {
        return this.manifest.shippings.findIndex(x => x.external_code !== null) !== -1
      },
      hasExternalOrderId() {
        return this.manifest.shippings.findIndex(x => x.external_order_id !== null) !== -1
      }
    },
    created () {
      this.fetchManifest()
    },
    beforeDestroy () {
      // this.$store.commit(CLEAR_FAQ)
    },
    methods: {
      fetchManifest() {
        const params = {
          includes: ['shippings', 'courier.courier_available.vehicle']
        }
        this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company.id + '/tours/' + this.id, {params: params})
          .then(response => {
            this.manifest = response.data
          })
      },
      print () {
      // Pass the element id here
        this.$htmlToPaper('manifest')
      },
      bulkExportLabels() {
        this.generatingLabels = true
        let params = {
          shippings: this.labelableShippings
        }
        this.$http.post(this.$appConfig.api.baseUrl + 'shippings/labels', params)
          .then(response => {
            window.open(response.body.label, JSON.stringify(this.labelableShippings))
            this.generatingLabels = false
            // TODO: force download (needs CORS on S3 or API passthrough)
            // this.$http.get(response.body.label, {responseType: 'blob'})
            //   .then(response => {
            //     try {
            //       const url = window.URL.createObjectURL(new Blob([response.data]))
            //       const link = document.createElement('a')
            //       link.href = url
            //       link.setAttribute('download', this.url.replace(/~/g, '.').split('/')[(this.url.split('/').length - 1)])
            //       document.body.appendChild(link)
            //       link.click()
            //       link.remove()
            //       window.URL.revokeObjectURL(url)
            //       this.downloaded = true
            //     } catch (e) {
            //       this.error = true
            //       this.downloaded = true
            //     }
            //   })
          })
      }
    }
  }
</script>

<style lang="scss">
.full-article-card {
  padding: 40px 60px;
  background-color: white;
  .card-body {
    padding: 0;
  }
}
.author-text.full-article-author-meta {
  background-color: rgba(0,0,0,0.02);
  padding: 1em 4em;
  margin: 30px -60px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 13px
}
.full-article-author-image {
  border-radius: 4px;
  max-height: 40px;
  display: inline-block;
}
#feedback {
  background-color: rgba(0,0,0,0.02);
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 4px;
  padding: 0em 1em 1em 1em;
  width: 100%;
  margin-top: 40px;
  h3 {
    margin: 1.2em 0 0.5em 0;
    text-align: center;
    font-weight: 500;
  }
  .btn-group {
    width: 100%;
    .btn {
      width: 33%;
      opacity: 0.6;
      transition: opacity 0.5s ease;
      &:hover {
        opacity: 1;
      }
    }
  }
}
.x {
  display: none;
}
</style>
